"use client";

import Link from "next/link";
import { ChoiceCard } from "@/features/quote/ui/ChoiceCard";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";

export function AudienceStep() {
  const { selectAudience, autoAdvance, next } = useWizard();
  const [{ audience }] = useStep("audience");

  return (
    <section>
      <StepHeading
        title="Hvad skal der rengøres?"
        body="Vælg først om det er til en privat bolig eller en virksomhed - det afgør hvilke firmaer vi matcher dig med."
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <ChoiceCard
          selected={audience === "privat"}
          onClick={() => {
            selectAudience("privat");
            autoAdvance();
          }}
          icon="/images/lineboil/01-flyttekasser-mini.webp"
          title="Privat bolig"
          body="Lejlighed, hus, rækkehus eller sommerhus. Løbende eller engangsrengøring."
        />
        <ChoiceCard
          selected={audience === "erhverv"}
          onClick={() => {
            selectAudience("erhverv");
            autoAdvance();
          }}
          icon="/images/lineboil/02-kontor-mini.webp"
          title="Virksomhed"
          body="Kontor, butik, klinik, restaurant, institution eller boligforening."
        />
      </div>
      <p className="mt-4 text-sm text-ink-subtle">
        Tilbyder I selv rengøring?{" "}
        <Link
          href="/bliv-partner"
          className="text-link underline underline-offset-2 hover:text-ink"
        >
          Så skal I være partner i stedet →
        </Link>
      </p>
      <StepNav onNext={next} nextEnabled={!!audience} nextLabel="Næste →" />
    </section>
  );
}
